enum TransactionType {
  Domain = "domain",
  Subscription = "subscription",
  Card = "card",
}

export default TransactionType;
